<template>

    <main class="preview">

        <div class="scroll-outer" ref="wrapper">
            <div ref="innerscroll" class="inner-scroll">

                <FeaturedHeader :scroll="offY"></FeaturedHeader>

                <div class="all-listings">
                    <div class="container n-mx">

                        <CatRow v-for="row in rows" :key="row.id+row.assets.length"
                            :rowTitle="row.name"
                        >
                            <RowCard v-for="asset,aIndex in row.assets" :key="aIndex"
                                :posterSrc="asset.poster"
                                :title="asset.name"
                                :description="asset.description"
                                :moneyTag="Global.plans[asset.planIndex].name"
                                :index="asset.index"
                                :progressPerc="asset.progressPerc"
                            ></RowCard>
                        </CatRow>

                    </div>
                </div>
        
            </div>
        </div>

        <!-- <div class="b-overlay"></div> -->

    </main>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar'
    import FeaturedHeader from '../../components/FeaturedHeader'
    import RowCard from '../../components/RowCard'
    import CatRow from '../../components/CatRow'

    class DisableScrollPlugin extends ScrollbarPlugin {
        static pluginName = 'disableScroll';
        static defaultOptions = {
            direction: '',
        };
        transformDelta(delta) {
            if (this.options.direction) {
                delta[this.options.direction] = 0;
            }
            return { ...delta };
        }
    }
    Scrollbar.use(DisableScrollPlugin);

    export default {

        name: 'Home',

        components: {
            FeaturedHeader,
            RowCard,
            CatRow
        },

        data() {
            return {
                Global,
                offY: 0,
            }
        },

        computed: {

            rows() {

                const rows = Object.assign([], this.Global.rows)
                return rows.map((row,index) => {
                    const lRow = Object.assign({}, row)
                    lRow.index = index
                    lRow.assets = lRow.assets.map((assetIndex) => {
                        const asset = Object.assign({}, this.Global.assets[assetIndex])
                        asset.index = assetIndex
                        if(lRow.content == "Continue Watching") {
                            asset.progressPerc = Math.floor(Math.random() * (80 - 10 + 1) + 10)
                        }
                        return asset
                    }).filter((asset) => asset.name)
                    return lRow
                })
            }
        },

        mounted() {
            this.init()
        },

        methods: {

            init() {
                this.scroll = Scrollbar.init(this.$refs.wrapper, {
                        syncCallbacks: true,
                        plugins: {
                            disableScroll: {
                            direction: 'x',
                            },
                        },
                    }
                );
                this.scroll.track.xAxis.element.remove()
                this.scroll.addListener(({ offset }) => {
                    this.offY = offset.y
                    this.$emit('scrollUpdate', this.offY)
                    if(offset.x > 0)
                        this.scroll.scrollLeft = 0
                });
            }

        },

    }

</script>